import { api, type ApiType } from 'lib/api';
import { stringParse } from 'utils';

export const apiStyleCategories: ApiType = {
  get: {
    list: () => api.get('api/styleCategories?isActive=true&pageSize=100'),
    search: ({ query, vars }) =>
      api.get(stringParse('/api/styleCategories?search={0}&isActive=true', vars), query),
  },
  put: {},
  post: {},
  delete: {},
};
